import React, { useState } from 'react'
 
 
import BudgetAllocationList from './BudgetAllocationList';
import BudgetAllocationForm from './BudgetAllocationForm';

const BudgetAllocation= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);

  return (
    <>
      {fromIsShown ? (
          <BudgetAllocationForm addForm={setFromIsShown} update={upData} />
        ) : (
          <BudgetAllocationList addForm={setFromIsShown} update={setUpData} />
        )}  
    </>
  )
}

export default BudgetAllocation